export class Usuario {

    public address: String;
    public addressComplement: String;
    public addressNumber: String;
    public birthDate2: String;//keep form string value
    public birthDate: number;
    public cep: String;
    public city: String;
    public cpf: String;
    public deviceId: String;
    public email: String;
    public fatherFullName: String;
    public fullName: String;
    public gender: String;
    public lat: Number;
    public lng: Number;
    public motherFullName: String;
    public neighborhood: String;
    public phoneNumber: String;
    public rg: String;
    public state: String;
    public userId: Number;
    public version: String;
    public token: String;
    public nacionalidade: String;
    public telefoneCelular: String;
    public estadoCivil: String;
    public responsavel: String;
    public tenant: Number;
    public senha: String;
    public empresa: boolean;
    public rgEmissionString: String;//keep form string value
    public rgEmission: number;
    public rgState: String;
    public rgAuthority: String;
    public socialName: string;
    public income: number;
}
